import { Col, List, Row, Typography } from 'antd'
import React from 'react'
import IconRatingSkill from './iconRating';
import iconWork from '../images/candidateCard/ico-work.png'
import icoEducation from '../images/candidateCard/ico-education.png'
import icoSkills from '../images/candidateCard/ico_skills.png'
import iconBtnAccept from '../images/candidateCard/btn-accept.png'
import iconBtnDecline from '../images/candidateCard/btn-decline.png'
import iconBtnAcceptFr from '../images/candidateCard/btn-accept-fr.png'
import iconBtnDeclineFr from '../images/candidateCard/btn-decline-fr.png'

import { Content } from 'antd/es/layout/layout';
import { useLocation } from 'react-router-dom';


// Interface
interface Props {
    educationListForm: Array<any>;
    experienceListForm: Array<any>;
    skillListForm: Array<any>;
}

// Component Ant Design
const { Text } = Typography;

// Component
const CandidateCard: React.FC<Props> = ({ educationListForm, experienceListForm, skillListForm }) => {
    const location = useLocation();
    return (
        <Row style={{ height: '100%', width: '100%' }}>
            <Row style={{ width: '100%', height: '70%', paddingBottom: 20 }}>
                <Col span={12} style={{ padding: 10, height: '100%' }}>
                    <Row style={{ width: '100%', height: '10%', display: 'flex', alignItems: 'center', paddingBottom: 20 }}>
                        <Col style={{ paddingLeft: 10, paddingRight: 40 }}>
                            <img
                                src={iconWork}
                                style={{ height: 40, width: 40 }}
                                alt={iconWork}
                            />
                        </Col>

                        <Col style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            <Text style={{ color: "#129BD4", fontSize: 24 }}>
                                Experience
                            </Text>
                        </Col>
                    </Row>

                    <Row style={{ width: '100%', height: '90%', overflow: 'auto', paddingRight: 12, paddingLeft: 40 }}>
                        {
                            experienceListForm.length > 0 ? (
                                <List
                                    style={{ height: '100%', width: '100%' }}
                                    dataSource={experienceListForm}
                                    renderItem={(experience, index) => {
                                        // Dividir la descripción de la experiencia actual en párrafos basados en '\n'
                                        const paragraphs = experience.description.split('\n');

                                        return (
                                            <Content style={{ height: 'auto', width: '100%', marginTop: index > 0 ? 10 : 0, minHeight: 70 }}>
                                                <Row style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'space-between' }}>
                                                    <Col span={17}>
                                                        <Text style={{ fontSize: 19, fontWeight: 'bold' }}>
                                                            {experience.title}  |  {experience.company}
                                                        </Text>
                                                    </Col>
                                                    <Col span={7} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Text style={{ fontWeight: "bold", fontSize: 18 }}>
                                                            {experience.dateStart.seconds && new Date(experience.dateStart.seconds * 1000).getFullYear()} -
                                                            {experience.actualPosition ? "PRESENT" : new Date(experience.dateEnd.seconds * 1000).getFullYear()}
                                                        </Text>
                                                    </Col>
                                                </Row>
                                                <Row style={{ marginTop: '1%' }}>
                                                    <Col xs={23} sm={23} md={23} lg={23} xxl={19}>
                                                        {paragraphs.map((paragraph: string, paragraphIndex: number) => (
                                                            <React.Fragment key={paragraphIndex}>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'flex-start', // Cambio para alinear con la primera línea del párrafo
                                                                    gap: 10,
                                                                    // Aumenta el espacio entre el bullet y el texto
                                                                }}>
                                                                    {/* Bullet mejorado */}
                                                                    <div style={{
                                                                        height: 7, // Hace el bullet más grande
                                                                        width: 7, // Mantiene la proporción del bullet
                                                                        borderRadius: '50%', // Asegura que el bullet sea perfectamente redondo
                                                                        backgroundColor: '#129BD4', // Cambia el color para un look más moderno, usa un color que combine con tu tema
                                                                        flexShrink: 0, // Evita que el bullet se encoja si el texto es muy largo
                                                                        marginTop: '0.7em', // Ajusta la alineación vertical del bullet con la primera línea del párrafo
                                                                    }} />
                                                                    {/* Texto */}
                                                                    <Text style={{ display: 'block', flex: 1, fontSize: 17 }}>{paragraph}</Text>
                                                                </div>
                                                                {/* Espacio adicional después de cada párrafo, excepto el último, con una solución más limpia */}
                                                                {paragraphIndex < paragraphs.length - 1 && <div style={{ height: '1em' }}></div>}
                                                            </React.Fragment>
                                                        ))}
                                                    </Col>
                                                </Row>


                                            </Content>
                                        );
                                    }}
                                />


                            ) : (
                                <div style={{ height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                                    <Text style={{ color: '#00000040', fontSize: 30 }}>No experience </Text>
                                </div>
                            )
                        }

                    </Row>
                </Col>

                <Col span={12} style={{ paddingLeft: 20 }}>
                    <Row style={{ width: '100%', height: '15%', display: 'flex', alignItems: 'center', paddingBottom: 20 }}>
                        <Col style={{ paddingLeft: 10, paddingRight: 40 }}>
                            <img
                                src={icoEducation}
                                style={{ height: 40, width: 40 }}
                                alt={icoEducation}
                            />
                        </Col>

                        <Col style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            <Text style={{ color: "#129BD4", fontSize: 24 }}>
                                Education
                            </Text>
                        </Col>
                    </Row>

                    <Row style={{ width: '100%', height: '85%', overflow: 'auto', paddingRight: 12 }}>
                        {
                            educationListForm.length > 0 ? (
                                <List
                                    dataSource={educationListForm}
                                    style={{ height: '100%', width: '100%' }}
                                    renderItem={(education) => (
                                        <Content style={{ height: '100%', width: '100%', marginTop: '3%' }}>
                                            <Row style={{ width: '100%' }}>
                                                <Col xs={{ span: 9, offset: 2 }} sm={{ span: 9, offset: 3 }} md={{ span: 10, offset: 2 }} lg={{ span: 4, offset: 2 }} xl={{ span: 5 }} xxl={{ span: 6, offset: 2 }}>
                                                    <Row style={{ width: '100%' }}>
                                                        <Col span={23}>
                                                            <Text style={{ fontSize: 17 }}>{education.degree}</Text>
                                                        </Col>

                                                        <Col span={1} style={{ textAlign: 'center', alignItems: 'center' }}>
                                                            <Text style={{ fontSize: 17, textAlign: 'center' }}>|</Text>
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                <Col xs={{ span: 12, offset: 1 }} sm={{ span: 11, offset: 1 }} md={{ span: 11, offset: 1 }} lg={{ span: 6, offset: 1 }} xl={{ span: 5, offset: 1 }} xxl={{ span: 5, offset: 1 }}>
                                                    <Row style={{ width: '100%' }}>
                                                        <Col span={23} style={{ textAlign: 'start', alignItems: 'center' }}>
                                                            <Text style={{ fontSize: 17 }}>{education.fieldStudy}</Text>
                                                        </Col>
                                                        <Col span={1} style={{ textAlign: 'center', alignItems: 'center' }}>
                                                            <Text style={{ fontSize: 17, textAlign: 'center' }}>|</Text>
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                <Col xs={{ span: 9, offset: 2 }} sm={{ span: 9, offset: 3 }} md={{ span: 10, offset: 2 }} lg={{ span: 6, offset: 1 }} xl={{ span: 5, offset: 1 }} xxl={{ span: 5, offset: 1 }} style={{ textAlign: 'center' }}>
                                                    <Row style={{ width: '100%' }}>
                                                        <Col span={23} style={{ textAlign: 'start', alignItems: 'center' }}>
                                                            <Text style={{ fontSize: 17, textAlign: 'center' }}> {education.institution}</Text>
                                                        </Col>

                                                        <Col span={1} style={{ textAlign: 'center', alignItems: 'center' }}>
                                                            <Text style={{ fontSize: 17, textAlign: 'center' }}>|</Text>
                                                        </Col>
                                                    </Row>

                                                </Col>

                                                <Col xs={{ span: 13 }} sm={{ span: 11, offset: 1 }} md={{ span: 11, offset: 1 }} lg={{ span: 2, offset: 1 }} xl={{ span: 3, offset: 1 }} xxl={{ span: 3, offset: 0 }}>
                                                    <Row style={{ width: '100%' }}>
                                                        <Col span={21} offset={2} style={{ textAlign: 'start', alignItems: 'center' }}>
                                                            <Text style={{ fontSize: 17 }}>{new Date(education.graduationDate.seconds * 1000).getFullYear()}</Text>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Content>
                                    )}
                                />
                            ) : (
                                <div style={{ height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                                    <Text style={{ color: '#00000040', fontSize: 30 }}>No experience </Text>
                                </div>
                            )
                        }

                    </Row>

                </Col>
            </Row>

            <Row style={{ width: '100%', height: '20%', display: 'flex', justifyContent: 'center', marginTop: 20 }}>
                <Row style={{ width: '100%', height: '10%', display: 'flex', alignItems: 'center' }}>
                    <Col style={{ paddingLeft: 10, paddingRight: 40 }}>
                        <img
                            src={icoSkills}
                            style={{ height: 40, width: 40 }}
                            alt={icoSkills}
                        />
                    </Col>

                    <Col style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                        <Text style={{ color: "#129BD4", fontSize: 24 }}>
                            Skills
                        </Text>
                    </Col>
                </Row>
                {skillListForm.length > 0 ?
                    skillListForm.map((skill) => (
                        <Col key={skill.level + skill.name} style={{ padding: 1, height: 30, marginRight: 40 }}>
                            <Row style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                <Col style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                        <IconRatingSkill rating={skill.level} />
                                    </div>
                                </Col>

                                <Col style={{ display: 'flex', alignItems: 'center', paddingLeft: 5 }}>
                                    <Text style={{ fontSize: 20 }}>{skill.name}</Text>
                                </Col>
                            </Row>
                        </Col>
                    )) :
                    <div style={{ height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <Text style={{ color: '#00000040', fontSize: 30 }}>No skills </Text>
                    </div>
                }
            </Row>

            <Row style={{ width: '100%', height: '10%', display: 'flex', justifyContent: 'center' }}>
                <Row style={{ width: "60%", paddingBottom: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Col xs={24} sm={12} md={12} lg={12} xxl={12}
                        style={{ height: '100%', display: "flex", justifyContent: "center", alignItems: "center" }}
                    >

                        <img
                            src={location.pathname === '/en/candidate' ? iconBtnAccept : iconBtnAcceptFr}
                            style={{ height: 80, width: 180, marginTop: -10 }}
                            alt={iconBtnAccept}
                        />
                    </Col>

                    <Col xs={24} sm={12} md={12} lg={12} xxl={12} style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>

                        <img
                            src={location.pathname === '/en/candidate' ? iconBtnDecline : iconBtnDeclineFr}
                            style={{ height: 80, width: 180, marginTop: -10 }}
                            alt={iconBtnAccept}
                        />
                    </Col>
                </Row>
            </Row>
        </Row>
    )
}

export default CandidateCard